<template>
    <div class="server-error">
      <div class="content">
        <h1>500 - Interne Serverfout</h1>
      <p>Er is iets misgegaan op de server.</p>
      <router-link to="/" class="home-link">Ga terug naar de homepagina</router-link>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ServerErrorPage',
  };
  </script>
  
  <style lang="scss" scoped>
  .server-error {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
  }
  
  .content h1 {
    font-size: 3rem;
    margin-bottom: 20px;
  }
  
  .content p {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  
  .home-link {
    font-size: 1.2rem;
    color: #007bff;
    text-decoration: none;
    transition: color 0.3s;
  }
  
  .home-link:hover {
    color: #0056b3;
  }
  </style>